import { Action } from "@/api-schema-enums";
import { useAbility } from "@/casl-provider";
import { generateUuidV4Regex } from "@/common/helpers/utils";
import { ForbiddenView } from "@/views/common/forbidden.view";
import { NotFoundView } from "@/views/common/notfound.view";
import { JobFunctionDetailView } from "@/views/job-function-detail/job-function-detail.view";
import { Route, Switch } from "wouter";
import { CreateView } from "./create/create.view";
import { JobFunctionView } from "./job-function.view";
import { UpdateView } from "./update/update.view";

export function JobFunctionRoutes() {
  const ability = useAbility();
  const jobFunctionUpdateUuidRegex = generateUuidV4Regex({ paramName: "uuid", suffix: "/update" });
  const jobFunctionDetailUuidRegex = generateUuidV4Regex({ paramName: "uuid" });
  const canManage = ability.can(Action.Manage, "JobFunction");

  return (
    <Switch>
      <Route path={"/"} component={JobFunctionView} />
      <Route path={"/create"} component={canManage ? CreateView : ForbiddenView} />
      <Route path={jobFunctionUpdateUuidRegex} component={canManage ? UpdateView : ForbiddenView} />
      <Route path={jobFunctionDetailUuidRegex} component={JobFunctionDetailView} />
      <Route component={NotFoundView} />
    </Switch>
  );
}
